import React, {useEffect} from 'react'

import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    GORGIAS_CONTACT_FORM_SCRIPT_URL,
    GORGIAS_FORM_UIDS,
    DEFAULT_GORGIAS_FORM_UID
} from '@app/constants'
import PropTypes from 'prop-types'
import useMultiSite from '../../../hooks/use-multi-site'

/**
 * PDCContactUsForm
 *
 * A simplified Page Designer component that embeds the external
 * Gorgias Hosted Contact Form.
 *
 *  @param {Object} props
 *  @param {string} [props.subTitle] - Optional Page Designer subtitle.
 *
 * @returns {JSX.Element} The rendered PDCContactUsForm component.
 */

export const PDCContactUsForm = ({subTitle}) => {
    const {locale, site} = useMultiSite()
    const formUID = GORGIAS_FORM_UIDS[site.id]?.[locale.id] || DEFAULT_GORGIAS_FORM_UID

    // <script defer src="https://contact.gorgias.help/api/contact-forms/loader.js?v=3" data-gorgias-loader-contact-form data-gorgias-contact-form-uid="hvrd13rl"></script>
    useEffect(() => {
        // Avoid double-injecting the script
        if (document.getElementById('gorgias-contact-form-loader')) return

        const script = document.createElement('script')
        script.defer = true
        script.id = 'gorgias-contact-form-loader'
        script.src = GORGIAS_CONTACT_FORM_SCRIPT_URL
        script.setAttribute('data-gorgias-loader-contact-form', '')
        script.setAttribute('data-gorgias-contact-form-uid', formUID)

        // Insert script right after the container
        const target = document.getElementById('gorgias-contact-form-target')
        target?.appendChild(script)
    }, [])

    return (
        <Box position={'relative'} width={'100%'} pb={{base: '60px', lg: 0}} overflow={'hidden'}>
            {subTitle && (
                <Box
                    mt={{base: '44px', lg: '34px'}}
                    px={{base: '10px', lg: '40px'}}
                    maxW={{base: 'unset', lg: '920px'}}
                >
                    <Text
                        variant={'bodyBase2'}
                        maxW={{base: 'unset', lg: '756px'}}
                        mb={'16px'}
                        dangerouslySetInnerHTML={{
                            __html: subTitle
                        }}
                    />
                </Box>
            )}

            {/* GORGIAS HOSTED CONTACT FORM */}
            <div id="gorgias-contact-form-target"></div>
        </Box>
    )
}

PDCContactUsForm.propTypes = {
    subTitle: PropTypes.string
}
